<script type="text/jsx">
import {
  computedPbxBasePlans,
  computedPbxPlans,
  computedPbxTollFreePlans,
  PBX_SUB_TYPES,
} from '@/common/service/computers/plans/pbx';
import mixin from '@/plans/mx/shopping-cart';
import { phoneNumberStorage, tollFreeNumberStore } from '@/plans/ZOOM_PHONE/store';
import { mapGetters } from 'vuex';
import PbxMixin from '@/plans/ZONE_PRO_PLUS/mixin/pbx-mixin';
import { logger } from '@/utils/log';

export default {
  mixins: [mixin, PbxMixin],
  computed: {
    ...mapGetters(['getSelectedPlans']),
    selectedPbxPlans() {
      return computedPbxPlans(this.getSelectedPlans);
    },
    isShowRmvBtn() {
      return this.$context.is.checkoutPage;
    },
    pbxAddonPlans() {
      return this.selectedPbxPlans.filter(item => [PBX_SUB_TYPES.FEATURE, PBX_SUB_TYPES.UNLIMITED_ADDON].includes(item.sub_type));
    },
  },
  methods: {
    handlerRemoveTFNumbers(plan) {
      tollFreeNumberStore.state.pickedNumberList = [];
      phoneNumberStorage.update('tollFreeNumberState', tollFreeNumberStore.state);
      this._dispatch('remove', plan);
      this.$tracking.orderSummary(
        `remove ${this.$pkg.components.addon ? 'add-on product' : 'product'} - ${this.$t(plan.planNameKey)}`,
      );
    },
    removeTFPlan(plan) {
      return (
        <zm-button
          type="link"
          aria-label={`${this.$t('billing.common.remove')} ${this.$t(plan.planNameKey)}`}
          onClick={this.handlerRemoveTFNumbers.bind(this, plan)}
        >
          {this.$t('billing.common.remove')}
        </zm-button>
      );
    },
    $renderCallingPlanContent(plan) {
      return (
        <div class="pbx-cart-part">
          {this.mx_subTitle(
            this.$t(`billing.pbx.cart_name.${plan?.pbxCategory ?? ''}`),
            plan.amount * plan.cartInfo.selected_number,
          )}
          {this.mx_discount(plan.plan_code)}
          <h2 class="opc-cart-item__text">
            {plan.cartInfo.selected_number} {this.$t('billing.planform.unit.user')}
          </h2>
          {this.mx_cycle(plan.billing_cycle)}
          {this.mx_edit(plan)}
        </div>
      );
    },
    $renderTollFreePlanContent(plan) {
      return (
        <div class="pbx-cart-part">
          {this.mx_subTitle(this.$t(`billing.pbx.cart_name.${plan.category}`), plan.amount * plan.cartInfo.selected_number)}
          {this.mx_discount(plan.plan_code)}
          <h2 class="opc-cart-item__text">
            {plan.cartInfo.selected_number} {this.$t('billing.planform.unit.number')}
          </h2>
          {this.mx_cycle(plan.billing_cycle)}
          {this.mx_edit(plan)}
          {this.isShowRmvBtn && this.removeTFPlan(plan)}
        </div>
      );
    },
    $renderCallingPlan() {
      const callingPlans = this.selectedZoneProPlusCallingPlans;
      if (!callingPlans.length) return;
      return callingPlans.map((plan) => this.$renderCallingPlanContent(plan));
    },
    $renderTollFreePlan() {
      const tollFreePlans = computedPbxTollFreePlans(this.getSelectedPlans);
      if (!tollFreePlans.length) return;
      return tollFreePlans.map((plan) => this.$renderTollFreePlanContent(plan));
    },
    $renderPbxBasePlan() {
      const pbxBasePlan = computedPbxBasePlans(this.getSelectedPlans)[0];
      if (!pbxBasePlan) return null;
      return (
        <div class="pbx-cart-part">
          {this.mx_subTitle(this.$t('billing.pbx.calling_fee_name.pay_you_go.MC'), pbxBasePlan.amount)}
          {this.mx_discount(pbxBasePlan.plan_code)}
          {this.mx_cycle(pbxBasePlan.billing_cycle)}
          {this.mx_edit(pbxBasePlan)}
        </div>
      );
    },
    $renderPbxAddons() {
      if (!this.pbxAddonPlans?.length) return null;

      logger.info("render pbx addon plan in pro plus context");

      return <div class="opc-cart-item">
        <h1 class="opc-cart-item__title text-capitalize">{this.$t('billing.planform.title.zoomphone')}</h1>
        {
          this.pbxAddonPlans.map(item => (
            <div class="pbx-cart-part" key={item.plan_code}>
              {this.mx_subTitle(this.$t(`billing.pbx.plan_name.${item.category}`), item.amount * item.cartInfo.selected_number)}
              {this.mx_discount(item.plan_code)}
              <h2 class="opc-cart-item__text">
                {item.cartInfo.selected_number} {this.$t('billing.planform.unit.number')}
              </h2>
              {this.mx_cycle(item.billing_cycle)}
              {this.mx_edit(item)}
              {this.isShowRmvBtn && this.mx_remove(item)}
            </div>
          ))
        }
      </div>;
    },
    $renderPrice() {
      return (
        <div>
          <div class="opc-cart-item">
            <h1 class="opc-cart-item__title text-capitalize">{this.$t('billing.zone_pro_plus.title')}</h1>
            {this.$renderCallingPlan()}
            {this.$renderTollFreePlan()}
            {this.$renderPbxBasePlan()}
          </div>
          {this.$renderPbxAddons()}
        </div>
      );
    },
  },
};
</script>
<style lang="scss">
.pbx-cart-part {
  margin-bottom: 10px;
}
</style>
